import { Typography } from '@mui/material';
import Box from '@mui/material/Box';
import { GenerationModelDetails } from '~/domain/dicom/dicomBase';
import { formatModalityHint } from '~/utils/transforms/predictionModelsDataTransforms';

type ModelDetailsProps = {
    generationModel?: GenerationModelDetails;
    fullWidth?: boolean;
};

export default function ModelDetails({
    generationModel,
    fullWidth,
}: ModelDetailsProps) {
    if (!generationModel?.label) {
        return null;
    }

    const modelName = generationModel.label || generationModel.name;
    const modelLabel = generationModel.version
        ? `${modelName} v. ${generationModel.version}`
        : modelName;
    const modalityHint = formatModalityHint(generationModel);
    const generatedLabel = modalityHint
        ? `AI Generated (${modalityHint})`
        : 'AI Generated';

    return (
        <Box
            display="grid"
            gridTemplateColumns="1fr auto"
            justifyContent="space-between"
            alignItems="center"
            gap={1}
            width={fullWidth ? '100%' : 'auto'}
            overflow="hidden"
        >
            <Typography
                fontSize={10}
                color="text.secondary"
                whiteSpace="nowrap"
                flexShrink={0}
            >
                {generatedLabel}
            </Typography>
            <Typography
                fontSize={10}
                color="text.secondary"
                noWrap
                title={modelLabel}
            >
                {modelLabel}
            </Typography>
        </Box>
    );
}
